<div class="container">
  <h1>Selecciona tu <span style="font-style: italic;">coach</span></h1>
</div>
<hr />
<div class="container" *ngIf="!loading else this.loadingTemplate">
  <p i18n>
    Sabemos lo importante que es que te sientas en confianza y en sintonía con la persona que te acompaña en este
    proceso. Si en algún momento consideras que te gustaría continuar tu seguimiento con otro especialista, puedes
    hacerlo.
  </p>
  <h2 i18n>Tu coach actual:</h2>
  <div class="dakkini-card CoachActual texture_secondary my-4">
    <div class="row">
      <div class="col-12 col-md-2">
        <div class="rounded__pic"
          [ngStyle]="{'width':'100px','height':'100px', 'borderRadius': '12px', 'backgroundColor': 'white', 'transition': 'all 0.3s'}"
          [style.background-image]="'url(' + actualCoach?.avatar + ')'">
        </div>
      </div>
      <div class="col-12 col-md-10">
        <h2>{{actualCoach?.full_name}}</h2>
        <div [innerHTML]="this.locale==='en' && actualCoach?.short_bio_en ? actualCoach?.short_bio_en : (actualCoach.short_bio ? actualCoach.short_bio : actualCoach.short_bio_en)"></div>
      </div>
    </div>
  </div>
  <h2 i18n>Otros coaches disponibles para ti:</h2>
  <div class="Therapists" *ngIf="this.specialists.length else noTherapistsTemplate">
    <div class="Therapists__Card" *ngFor="let specialist of specialists">
      <div class="header">
        <div class="rounded__pic" [ngStyle]="{'width':'100px','height':'100px', 'borderRadius': '12px'}"
          [style.background-image]="'url('+specialist.avatar+')'">
        </div>
        <div class="languages">
          <p class="d-flex align-items-center gap-2 mb-0">
            <span *ngIf="specialist.lang_en" class="bh-languages" i18n>Inglés</span>
            <span class="bh-languages" *ngIf="specialist.lang_es" i18n>Español</span>
          </p>
        </div>
      </div>
      <div>
        <h1 class="Therapists__Card--name">{{specialist.full_name}}</h1>
        <p class="Therapists__Card--description">{{ this.locale==='en' && specialist?.title_en ? specialist?.title_en
          : (specialist.title ? specialist.title : specialist.title_en)}}</p>
        <div class="Therapists__Card--short_bio"
          [innerHTML]="this.locale==='en' && specialist?.short_bio_en ? specialist?.short_bio_en : (specialist.short_bio ? specialist.short_bio : specialist.short_bio_en)">
        </div>
      </div>
      <div class="mt-auto">
        <button class="btn btn-primary col-12" (click)="changeCoach(specialist.id)" i18n>Seleccionar coach</button>
      </div>
    </div>
  </div>
</div>


<ng-template #loadingTemplate>
  <loading-dots-component></loading-dots-component>
</ng-template>

<ng-template #noTherapistsTemplate>
  <div class="container-fluid text-center d-flex flex-column justify-content-center" style="min-height: 400px;">
    <h3 i18n>Por el momento no hay ningún especialista disponible.</h3>
    <p i18n>Intenta más tarde.</p>
  </div>
</ng-template>